module.exports = __webpack_public_path__ + "img/GBG.49c7e420.svg";